<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户编号" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户编号" />
      </a-form-model-item>
      <a-form-model-item label="收入/支出" prop="inOut" >
        <a-input v-model="form.inOut" placeholder="请输入收入/支出" />
      </a-form-model-item>
      <a-form-model-item label="类型" prop="type" >
      </a-form-model-item>
      <a-form-model-item label="关联资源编号" prop="resourceId" >
        <a-input v-model="form.resourceId" placeholder="请输入关联资源编号" />
      </a-form-model-item>
      <a-form-model-item label="初始战刀" prop="originalIntegralNum" >
        <a-input v-model="form.originalIntegralNum" placeholder="请输入初始战刀" />
      </a-form-model-item>
      <a-form-model-item label="战刀数量" prop="integralNum" >
        <a-input v-model="form.integralNum" placeholder="请输入战刀数量" />
      </a-form-model-item>
      <a-form-model-item label="当前比例" prop="ratio" >
        <a-input v-model="form.ratio" placeholder="请输入当前比例" />
      </a-form-model-item>
      <a-form-model-item label="说明" prop="message" >
        <a-input v-model="form.message" placeholder="请输入说明" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getIncomeBill, addIncomeBill, updateIncomeBill } from '@/api/platform/incomeBill'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        inOut: null,

        type: null,

        resourceId: null,

        originalIntegralNum: null,

        integralNum: null,

        ratio: null,

        message: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        inOut: null,
        type: null,
        resourceId: null,
        originalIntegralNum: null,
        integralNum: null,
        ratio: null,
        message: null,
        createTime: null,
        remark: null,
      }
    /*  this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })*/
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getIncomeBill({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateIncomeBill(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addIncomeBill(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
